import { RefreshDouble } from 'iconoir-react'
import SimpleTable from 'app/components/table/SimpleTable'
import type { UseSchedulingAppointmentTypesReturn } from './useSchedulingAppointmentTypes'

export type SchedulingAppointmentTypesComponentProps = UseSchedulingAppointmentTypesReturn

export function SchedulingAppointmentTypesComponent({
  rows,
  isSyncing,
  columns,
  onRefreshClick,
}: SchedulingAppointmentTypesComponentProps) {
  return (
    <div className="mt-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-ui-sm text-strong">Types</p>
        <button className="btn btn-xs btn-tertiary gap-2" disabled={isSyncing} onClick={() => onRefreshClick()}>
          <RefreshDouble className={isSyncing ? `animate-spin` : ``} /> <p>Sync appointment types</p>
        </button>
      </div>
      <SimpleTable
        columns={columns}
        data={rows}
        showColumnOrdering={false}
        noDataMessage="No appointment types found"
        hideFooter={true}
      />
    </div>
  )
}
